import React from 'react'

import { Label } from '@octane/spark'

interface Props {
    value: string
}

function getColor(value: string) {
    if (value === 'Admin') return 'sapphire'

    if (value === 'Regional Manager') return 'cornflower'

    if (value === 'Sales') return 'umber'

    return 'moss'
}

export default function LevelOfAccess({ value }: Props) {
    return (
        <div style={{ width: '100%', textAlign: 'left', whiteSpace: 'nowrap' }}>
            <Label text={value} color={getColor(value)} size="small" />
        </div>
    )
}
